module.exports = __webpack_public_path__ + "img/funcionario.1a4c7603.png";